
import RcDomainObject from "@/domain/common/RcDomainObject.js";
import User from "@/domain/model/user/User.js";
// import StringUtils from '@/utils/StringUtils.js';
import Company from "../company/Company";
import LabelMap from "./LabelMap";
import AddressMap from "../address/AddressMap";

export default class Label extends RcDomainObject {

  static MODEL_NAME = "Label";

  constructor(domain, data) {
    super(domain, data, Label.MODEL_NAME);
  }

  static Fields = {
    NAME: "name",
    ABBREVIATION: "abbreviation",
    TYPE: "type",
    DESCRIPTION: "description",
    COMPANY: "Company",
    ADDRESS_MAP: "AddressMap",
    EMAIL_ALL_VEHICLE_INSPECTIONS: "emailAllVehicleInspections",
    EMAIL_DEFECT_VEHICLE_INSPECTIONS: "emailDefectVehicleInspections",
    EMAIL_ALL_EQUIPMENT_INSPECTIONS: "emailAllEquipmentInspections",
    EMAIL_DEFECT_EQUIPMENT_INSPECTIONS: "emailDefectEquipmentInspections",
  }

  fields() {
    return Label.Fields;
  }

  copy() {
    var data = this._copy();
    return new Label(this.domain, data);
  }

  find() {
    var labelsDomain = this.domain.labels();
    var label = labelsDomain.findById(this.id());
    return label;
  }

  name() {
    return this.getString(Label.Fields.NAME);
  }

  withName(name) {
    this.put(Label.Fields.NAME, name);
    return this;
  }

  withDescription(value) {
    this.put(Label.Fields.NAME, value);
    return this;
  }

  isTypeDivision() {
    return this.type() === 'division';
  }

  isTypeGroup() {
    return this.type() === 'group';
  }

  type() {
    return this.getString(Label.Fields.TYPE);
  }

  withType(value) {
    this.put(Label.Fields.TYPE, value);
    return this;
  }

  description() {
    return this.getString(Label.Fields.DESCRIPTION);
  }

  withCompany(parent) {
    this.put(Label.Fields.COMPANY, parent.id());
    return this;
  }

  company() {
    return new Company(this.domain, this.get(Label.Fields.COMPANY));
  }

  map() {
    const map = new LabelMap(this.domain);
    map.addLabel(this);
    return map;
  }

  modifiedBy() {
    return new User(this.domain, this.get(RcDomainObject.DefaultFields.MODIFIED_BY));
  }

  createdBy() {
    return new User(this.domain, this.get(RcDomainObject.DefaultFields.CREATED_BY));
  }

  addressMap() {
    return new AddressMap(this.domain, this.get(Label.Fields.ADDRESS_MAP));
  }

  allVehicleInspectionsEmailList() {
    return this.getString(Label.Fields.EMAIL_ALL_VEHICLE_INSPECTIONS);
  }

  withAllVehicleInspectionsEmailList(list) {
    this.put(Label.Fields.EMAIL_ALL_VEHICLE_INSPECTIONS, list);
    return this;
  }

  defectVehicleInspectionsEmailList() {
    return this.getString(Label.Fields.EMAIL_DEFECT_VEHICLE_INSPECTIONS);
  }

  withDefectVehicleInspectionsEmailList(list) {
    this.put(Label.Fields.EMAIL_DEFECT_VEHICLE_INSPECTIONS, list);
    return this;
  }

  allEquipmentInspectionsEmailList() {
    return this.getString(Label.Fields.EMAIL_ALL_EQUIPMENT_INSPECTIONS);
  }

  withAllEquipmentInspectionsEmailList(list) {
    this.put(Label.Fields.EMAIL_ALL_EQUIPMENT_INSPECTIONS, list);
    return this;
  }

  defectEquipmentInspectionsEmailList() {
    return this.getString(Label.Fields.EMAIL_DEFECT_EQUIPMENT_INSPECTIONS);
  }

  withDefectEquipmentInspectionsEmailList(list) {
    this.put(Label.Fields.EMAIL_DEFECT_EQUIPMENT_INSPECTIONS, list);
    return this;
  }

  withAbbreviation(name) {
    this.put(Label.Fields.ABBREVIATION, name);
    return this;
  }

  abbreviation() {
    return this.getString(Label.Fields.ABBREVIATION);
  }
  
  pointer() {
    var item = new Label(this.domain);
    item.withId(this.id());
    return item;
  }
}